import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useWardList(params) {
  return useSWR(
    !!params
      ? {
          path: `/api/v1/addresses/wards`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useWardList;
